import { ReactNode } from 'react'

export default function ErrorMessage({
  children,
}: {
  children: string | ReactNode
}) {
  return <p className="mt-1 text-sm text-red-600">{children}</p>
}
